import FindLocationResultState from './data/schema/FindLocationResultState';
import { LocationPersonaControlViewState } from 'owa-location-persona';

export default {
    resolveSelectedLocation: {
        name: 'resolveSelectedLocation',
        customData: (
            findLocationResultState: FindLocationResultState,
            newLocation: LocationPersonaControlViewState | string
        ) => {
            let locationDisplayName: string;

            if (typeof newLocation === 'string') {
                locationDisplayName = newLocation;
            } else {
                locationDisplayName = newLocation.displayName || '';
            }

            return {
                TotalLength: locationDisplayName.length,
                TotalDigits: locationDisplayName.replace(new RegExp('[^\\d]', 'g'), '').length,
                Index:
                    typeof newLocation !== 'string' &&
                    findLocationResultState.findResultSet.indexOf(newLocation),
                QueryLength: findLocationResultState.queryString.length,
                IsResource: false, // Conference rooms are not supported yet
                SelectionSource:
                    typeof newLocation === 'string' ? 'string' : newLocation.selectionSource,
                LocationSource:
                    typeof newLocation !== 'string' &&
                    newLocation.postalAddress &&
                    newLocation.postalAddress.LocationSource,
                RelevanceHint:
                    typeof newLocation !== 'string' && newLocation.relevanceData.relevanceHint,
            };
        },
    },
};
